module.exports = __webpack_public_path__ + "img/timeline-01.590121df.jpg";